<div class="rrss">
    <div class="container-toyowidget" *ngIf="!visible">
        <div class="capsule">
            <div class="rrss-nm">WhatsApp</div>
            <a class="toyowidget call" href="tel:800101727" target="_blank">
                <img [src]="imgcall" width="40" height="40" alt="Icono de whatsapp" class="widget-wp"/>
            </a>
        </div>
    </div>
    <div class="container-toyowidget" *ngIf="!visible">
        <div class="capsule">
            <div class="rrss-nm">WhatsApp</div>
            <a class="toyowidget wp" href="https://api.whatsapp.com/send?phone=+59175096050&text=Hola,%20estaba%20en%20la%20página%20web%20y%20tengo%20una%20consulta" target="_blank">
                <img [src]="imgwhatsapp" width="40" height="40" alt="Icono de whatsapp" class="widget-wp"/>
            </a>
        </div>
    </div>
    <div class="rrss-text" *ngIf="!visible">
        <div class="rrss-text_com">
            Contáctanos
        </div>
    </div>

</div>